<div class="page-content">
  <form [formGroup]="formGroup" (ngSubmit)="submit($event)" autocomplete="off">
    <h1>Reset Password</h1>
    <h2></h2>
    <mat-form-field appearance="outline">
      <mat-label>Password</mat-label>
      <input
        matInput
        placeholder=""
        type="password"
        formControlName="password"
      />
      <mat-icon matPrefix>lock</mat-icon>
      <mat-error>At least 8 characters and 1 uppercase letter.</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Confirm Password</mat-label>
      <input
        matInput
        placeholder=""
        type="password"
        formControlName="password_confirmation"
      />
      <mat-icon matPrefix>lock</mat-icon>
      <mat-error>Please confirm your password.</mat-error>
    </mat-form-field>
    <app-button type="filled" [loading]="loading">Reset</app-button>
  </form>
</div>
